import React, { useState, useEffect } from "react";

import CreateAppBtn from "../../CommonCompnents/CreateAppBtn";
import appUrl from "../../../config/MyApp/myAppsURLConfig";
import DefaultAppIcon from "../../../assets/images/defaultAppIcon.svg";
import { MYAPP_TITLE } from "../../../Containers/Client/MyApp/myAppConstents";
import StaticIpBanner from "../../../assets/new_images/static_ip_banner.svg";
import HandPointer from "../../../assets/new_images/hand_pointer.svg";
import StaticIpModal from "./StaticIpModal";
import {staticIpPrimaryValidate,staticIpSecondaryValidate} from "../../utils/formValidate";
import { config } from "../../../config/domain";

const MyAppsComponent = (props) => {
  const { windowWidth, setWindowWidth } = useState(window.innerWidth);
  const [showStaticIpModal,setShowStaticIpModal] = useState(false)
  const {
    appFormHandler,
    appsData,
    showDeleteModal,
    showAnalyticsModal,
    setIsServerErr,
    isServerErr,
    onPreviousIPSubmit,
  } = props;

  const [showAdditionalFeatures, setShowAdditionalFeatures] = useState({
    isShow: false,
    isId: "",
  });

  const [copyItem, setCopyItem] = useState({
    isCopied: false,
    appNm: "",
    copiedItem: "",
  });
  const [showApiModal, setApiModal] = useState("");
  const [staticIpModal, setStaticIpModal] = useState({
    isOpen: false,
    appData: "",
  });
  const [staticIpData, setStaticIpData] = useState({
    primaryIp: "",
    secondaryIp: "",
  });
  const [staticIpError, setStaticIpError] = useState({
    primaryIp: "",
    secondaryIp: "",
  });

  const showExistingFunction = (val) => {
    setShowAdditionalFeatures({
      isShow: !showAdditionalFeatures.isShow,
      isId: val,
    });
  };

  const showApiBox = (val) => {
    if (window.innerWidth <= 760) {
      setApiModal(val);
    } else {
      setApiModal("");
    }
  };

  const clickToCopy = (e, value, item, app) => {
    console.log(e.target);
    e.preventDefault();
    setCopyItem({
      isCopied: true,
      appNm: app,
      copiedItem: item,
    });
    navigator.clipboard.writeText(value);
  };

  const hitEditBtn = (app) => {
    let isOpen = true;
    let titlel = MYAPP_TITLE.EDIT;
    let appData = app;
    appFormHandler(isOpen, titlel, appData);
  };

  const createAppBtnHandler = (isOpen, title, appData) => {
    let _appData = {
      ...appData,
      ipEditable: true
    }
    if (appsData.actApps >= appsData.alwdActApps) {
      setIsServerErr({
        ...isServerErr,
        limitExceeded: `Only ${appsData.alwdActApps} Active app is allowed.`,
      });
    } else {
      appFormHandler(isOpen, title, _appData);
    }
  };

  useEffect(() => {
    if (window.innerWidth > 760) {
      setApiModal("");
    }
  }, [windowWidth]);

  useEffect(() => {
    if (copyItem.isCopied) {
      setTimeout(() => {
        setCopyItem({
          isCopied: false,
          appNm: "",
          copiedItem: "",
        });
      }, 1000);
    }
  }, [copyItem]);

  const openStaticIpModal = (app) => {
  setStaticIpModal({ isOpen: true, appData: app });
  setStaticIpData({ primaryIp: "", secondaryIp: "" });
  setStaticIpError({ primaryIp: "", secondaryIp: "" });
};

const closeStaticIpModal = () => {
  setStaticIpModal({ isOpen: false, appData: "" });
};

const handleStaticIpChange = (e) => {
  const { name, value } = e.target;
  setStaticIpData({ ...staticIpData, [name]: value });
};

const handleStaticIpSubmit = () => {
  let primaryErr = staticIpPrimaryValidate(staticIpData.primaryIp);
  let secondaryErr = staticIpSecondaryValidate(staticIpData.secondaryIp,staticIpData.primaryIp);
  if (primaryErr !== true || secondaryErr !== true) {
    setStaticIpError({
      primaryIp: primaryErr !== true ? primaryErr : "",
      secondaryIp: secondaryErr !== true ? secondaryErr : "",
    });
    return;
  }
  // Proceed with API call
  onPreviousIPSubmit({
      appData: staticIpModal.appData,
      appName: staticIpModal.appData.appNm,
      redirectUri: staticIpModal.appData.rdUrl,
      primaryIp: staticIpData.primaryIp,
      secondaryIp: staticIpData.secondaryIp
    });
  closeStaticIpModal();
};


  return (
    <div>
      <div>
        <div className="myAppWrap ">
          <h3 className="myAppCount-head">My Apps</h3>
          <div className="display-space-between myAppCount">
            <div className="display-space-between">
              <div className="count">
                <h3>My Total Apps</h3>
                <p>{appsData && appsData.ntApps}</p>
              </div>
              <div className="count">
                <h3>Active Apps</h3>
                <p>{appsData && appsData.actApps}</p>
              </div>
            </div>
            <CreateAppBtn
              appFormHandler={createAppBtnHandler}
              title={MYAPP_TITLE.CREATE}
            />
          </div>
          {appsData?.apps?.some(app => app.addStaticIpLink) && (
            <div className="staticIpWarningMsg">
              <span style={{fontWeight: 600, color:'#F7943E'}}>Important Note:</span> Please add Static IP address by 1st Oct 2025 for continued access to APIs. <span onClick={() => setShowStaticIpModal(true)} style={{textDecoration: 'underline',cursor: 'pointer'}}>Read more</span>
            </div>
          )}
          <div className="table-responsive">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>
                    <p>Name</p>
                  </th>
                  <th>
                    <p>API Key</p>
                  </th>
                  <th>
                    <p>API Secret Key</p>
                  </th>

                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {appsData &&
                  appsData.apps.map((app, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div
                            className="app_logo_with_name"
                            onClick={() => showApiBox(app)}
                          >
                            <img
                              className="table_app_logo"
                              src={
                                app.flLnk
                                  ? appUrl.appIcon + app.flLnk
                                  : DefaultAppIcon
                              }
                              alt="App Icon"
                            />

                            <h4>{app.appNm}</h4>
                          </div>
                        </td>
                        <td>
                          <div className="apiKey">
                            <span>{app.apiKey}</span>
                            <i
                              className="edel-icon-select pointer"
                              onClick={(e) => {
                                clickToCopy(
                                  e,
                                  app.apiKey,
                                  "Api Key",
                                  app.appNm
                                );
                              }}
                            ></i>
                          </div>
                        </td>
                        <td>
                          <div style={{display:'flex',justifyContent: 'space-between'}}>
                            <span
                              className="blue-txt pointer"
                              onClick={(e) =>
                                clickToCopy(
                                  e,
                                  app.secKey,
                                  "Secret Key",
                                  app.appNm
                                )
                              }
                            >
                              Click here to copy
                            </span>
                            {app.addStaticIpLink && (<span className="addStaticIp" onClick={() => openStaticIpModal(app)}>Add Static IP</span>)}
                          </div>
                        </td>
                        <td>
                          <p
                            className={`sq_badge ${
                              app.sts === "Active" ? " green_bdg" : " red_bdg"
                            }  green_bdg`}
                          >
                            {app.sts}
                          </p>
                        </td>
                        <td>
                          <i
                            className="edel-icon-dots-three-horizontal tooltip"
                            id="tooltip"
                            onClick={() => showExistingFunction(index)}
                          >
                            <ul
                              class="tooltiptext"
                              id={
                                showAdditionalFeatures.isShow &&
                                index === showAdditionalFeatures.isId
                                  ? "show_modal"
                                  : "hide_modal"
                              }
                            >
                              <li onClick={() => hitEditBtn(app)}>
                                <a href="#">Edit</a>
                              </li>
                              <li onClick={() => showDeleteModal(true, app)}>
                                <a href="#">Delete</a>
                              </li>
                              <li onClick={() => showAnalyticsModal(true, app)}>
                                <a href="#">View Analytics</a>
                              </li>
                            </ul>
                          </i>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="creatBt-mobile">
          <CreateAppBtn
            appFormHandler={createAppBtnHandler}
            title={MYAPP_TITLE.CREATE}
          />
        </div>
      </div>

      {copyItem.isCopied && (
        <div className="copied_container">
          <div className="copied_item">
            <p>{`"${copyItem.appNm}" App ${copyItem.copiedItem} Copied`}</p>
          </div>
        </div>
      )}

      {showApiModal !== "" && (
        <div class="modal_api">
          <div className="apiModelContent">
            <div className="closeIcon">
              <i
                className="edel-icon-close"
                onClick={() => {
                  showApiBox("");
                }}
              ></i>
            </div>
            <div className="table-responsive">
              <table className="custom-table">
                <tbody>
                  <tr>
                    <td>
                      <div className="app_logo_with_name">
                        <img
                          className="table_app_logo"
                          src={
                            showApiModal.flLnk
                              ? appUrl.appIcon + showApiModal.flLnk
                              : DefaultAppIcon
                          }
                          alt="app icon"
                        />
                        <span>{showApiModal.appNm}</span>
                      </div>
                    </td>
                    <td>
                      <p
                        className={`sq_badge ${
                          showApiModal.sts === "Active"
                            ? " green_bdg"
                            : " red_bdg"
                        }  green_bdg`}
                      >
                        {showApiModal.sts}
                      </p>
                    </td>
                    <td>
                      <i
                        className="edel-icon-dots-three-horizontal tooltip"
                        onClick={() => showExistingFunction()}
                      >
                        <ul
                          class="tooltiptext"
                          id={
                            showAdditionalFeatures.isShow
                              ? // index === showAdditionalFeatures.isId
                                "show_modal"
                              : "hide_modal"
                          }
                        >
                          <li onClick={() => hitEditBtn(showApiModal)}>
                            <a href="#">Edit</a>
                          </li>
                          <li
                            onClick={() => showDeleteModal(true, showApiModal)}
                          >
                            <a href="#">Delete</a>
                          </li>
                          <li
                            onClick={() =>
                              showAnalyticsModal(true, showApiModal)
                            }
                          >
                            <a href="#">View Analytics</a>
                          </li>
                        </ul>
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="copy_section">
              <div className="copy_section_flex">
                <div>
                  <span>Api Key</span>
                  <p>{showApiModal.apiKey}</p>
                </div>
                <button
                  onClick={(e) => {
                    clickToCopy(
                      e,
                      showApiModal.apiKey,
                      "Api Key",
                      showApiModal.appNm
                    );
                  }}
                >
                  Copy
                </button>
              </div>
              <div className="copy_section_flex">
                <div>
                  <span>App Secret Key</span>
                  <p>
                    &#x25cf; &#x25cf; &#x25cf; &#x25cf; &#x25cf; &#x25cf;
                    &#x25cf; &#x25cf;
                  </p>
                </div>
                <button
                  onClick={(e) => {
                    clickToCopy(
                      e,
                      showApiModal.secKey,
                      "Secret Key",
                      showApiModal.appNm
                    );
                  }}
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showStaticIpModal && (
        <div id={showStaticIpModal ? "show_modal" : "hide_modal"} >
          <div className="static-ip-modal-overlay">
            <div className="static-ip-modal">
              <div className="modal-header">
                <h3>Static IP Address needed<br />for continued API access</h3>
                <i className="edel-icon-close" onClick={() => setShowStaticIpModal(false)} />
              </div>

              <p className="modal-description">
                To comply with SEBI’s latest circular on algorithmic trading, all users accessing APIs must register a static IP address. This is mandatory before October 1st for continued and secure trading access.
                <br /><br />
                <button className="ed_button link modal-link"
                  onClick={() => {
                    window.open(
                      `${config.rootUrl}ewwebimages/webfiles/api-connect/nse_algo_circular.pdf`,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  Click here to read the circular for more information
                </button>
                <br /><br />
                Contact your Internet Service Provider and request a Static IP.
              </p>

              <div className="modal-info-block">
                <span>Add an IP address by clicking as shown on the listing page below.</span>
                <div style={{position: 'relative'}}>
                  <img src={HandPointer} className="hand_pointer"/>
                  <img src={StaticIpBanner} alt="Instruction Example" />
                </div>
              </div>

              <div className="modal-warning">
                <strong style={{color: '#F7943E'}}>Important Note:</strong> Failing to update your IP address by 1st Oct 2025, access to API will be blocked.
              </div>

              <button className="custom-btn block-btn" style={{width: '100%', borderRadius: '6px'}} onClick={() => setShowStaticIpModal(false)}>
                Ok, Understood.
              </button>
            </div>
          </div>
        </div>
      )}

      {staticIpModal.isOpen && <StaticIpModal
                            staticIpModal={staticIpModal}
                            closeModal={closeStaticIpModal}
                            appData={staticIpModal.appData}
                            onSubmit={handleStaticIpSubmit}
                            onChange={handleStaticIpChange}
                            error={staticIpError}
                            />}

    </div>
  );
};

export default MyAppsComponent;
